var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isError)?_c('page-result',{attrs:{"image":_vm.imgError,"title":"错误提示","desc":"请在微信或支付宝中打开该链接"}}):_c('router-view')}
var staticRenderFns = []

export { render, staticRenderFns }